import React from 'react';

interface ConsiderationsTabProps {
  reportData?: any;
}

const ConsiderationsTab: React.FC<ConsiderationsTabProps> = ({ reportData }) => {
  // Default data in case no report data is provided
  const resistanceConsiderations = [
    {
      title: "ESBL-producing organisms detected",
      description: "Avoid cephalosporins and penicillins. Consider carbapenems or beta-lactam/beta-lactamase inhibitor combinations."
    }
  ];
  
  const treatmentConsiderations = [
    {
      title: "Dosage Adjustment",
      description: "Consider dose adjustments for renal/hepatic impairment, age, weight, and drug interactions."
    },
    {
      title: "Duration of Therapy",
      description: "Reassess need for continued therapy based on clinical response and microbiology results."
    }
  ];
  
  const patientConsiderations = [
    {
      title: "Medication Reconciliation",
      description: "Review current medications for potential interactions with antimicrobial therapy."
    }
  ];

  return (
    <div className="p-6">
      <div className="mb-8">
        {/* Special Considerations Header */}
        <h3 className="text-lg font-semibold text-text mb-6">Special Considerations</h3>

        {/* Resistance Considerations */}
        <div className="mb-8">
          <h4 className="font-medium text-text mb-4">Resistance Considerations</h4>
          
          <div className="space-y-6">
            {resistanceConsiderations.map((consideration, index) => (
              <div key={index} className="ml-8">
                <p className="font-medium mb-1">{consideration.title}</p>
                <p className="text-sm text-gray-600">
                  {consideration.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Treatment Considerations */}
        <div className="mb-8">
          <h4 className="font-medium text-text mb-4">Treatment Considerations</h4>
          
          <div className="space-y-6">
            {treatmentConsiderations.map((consideration, index) => (
              <div key={index} className="ml-8">
                <p className="font-medium mb-1">{consideration.title}</p>
                <p className="text-sm text-gray-600">
                  {consideration.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Patient-specific Considerations */}
        <div>
          <h4 className="font-medium text-text mb-4">Patient-specific Considerations</h4>
          
          <div className="space-y-6">
            {patientConsiderations.map((consideration, index) => (
              <div key={index} className="ml-8">
                <p className="font-medium mb-1">{consideration.title}</p>
                <p className="text-sm text-gray-600">
                  {consideration.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsiderationsTab; 